let initializedGoogleMeasurementId = null;
let initializedClarityProjectId = null;
let clarityModulePromise = null;

export const initializePublicAnalyticsProviders = async (config, doc = document) => {
  initGoogleAnalytics(config.googleAnalyticsMeasurementId, doc);
  await initMicrosoftClarity(config.microsoftClarityProjectId);
};

export const resetPublicAnalyticsProviderStateForTests = () => {
  initializedGoogleMeasurementId = null;
  initializedClarityProjectId = null;
  clarityModulePromise = null;
};

const loadGoogleTag = (measurementId, doc = document) => {
  const scriptId = `ga4-${measurementId}`;
  if (doc.getElementById(scriptId)) return;

  const script = doc.createElement('script');
  script.id = scriptId;
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`;
  doc.head.appendChild(script);
};

const initGoogleAnalytics = (measurementId, doc = document) => {
  if (!measurementId || initializedGoogleMeasurementId === measurementId) return;

  const win = doc.defaultView || window;

  win.dataLayer = win.dataLayer || [];
  win.gtag = win.gtag || function gtag() {
    win.dataLayer.push(arguments);
  };

  loadGoogleTag(measurementId, doc);

  win.gtag('js', new Date());
  // Enhanced measurement reads current page metadata on history changes.
  win.gtag('config', measurementId);
  initializedGoogleMeasurementId = measurementId;
};

const clarityModule = async () => {
  clarityModulePromise ||= import('@microsoft/clarity');
  const imported = await clarityModulePromise;
  return imported.default || imported;
};

const initMicrosoftClarity = async (projectId) => {
  if (!projectId) return;

  const Clarity = await clarityModule();

  if (initializedClarityProjectId !== projectId) {
    Clarity.init(projectId);
    initializedClarityProjectId = projectId;
  }

  Clarity.consent(true);
};
